import type { GameSessionFactory } from '../app/types.js';
import {
  createDefaultAIClient,
  createDefaultClock,
  createDefaultIdGenerator,
  createConsoleLogger,
} from './deps.js';
import { createGameSessionController } from './create-game-session-controller.js';
import type { GameSessionControllerDeps } from './types.js';

export function createGameSessionFactory(
  deps: GameSessionControllerDeps,
): GameSessionFactory {
  return {
    async createLive(matchId) {
      const controller = createGameSessionController(deps, {
        mode: 'live',
        aiEnabled: true,
      });
      const existing = await deps.matchRepository.get(matchId);
      if (existing) {
        await controller.resume(matchId);
      }
      return controller;
    },
    async createReplay(matchId) {
      const controller = createGameSessionController(deps, {
        mode: 'replay',
        aiEnabled: false,
      });
      await controller.resume(matchId);
      return controller;
    },
  };
}

export function createDefaultSessionDeps(
  bundle: Pick<
    GameSessionControllerDeps,
    'matchRepository' | 'matchPersistence' | 'adaptiveProfile'
  >,
): GameSessionControllerDeps {
  return {
    ...bundle,
    aiClient: createDefaultAIClient(),
    clock: createDefaultClock(),
    idGenerator: createDefaultIdGenerator(),
    logger: createConsoleLogger('session'),
  };
}
